export default {
	// ? README: the url should be hostname/__type__/__id__ ?c&ct&la [currency, country_code, locale]
	// ? __type__: u = player [type: 3]
	// ? __type__: a = agent [type: 1]
	// ? __type__: af = affiliate [type: 2]
	// ? __id__: username ID
	async middleware({ store, redirect, req, res, $config }) {
		try {
			const { type, id: userId } = store.app.context.params;
			const isValidUser = (type, userId) => {
				return ['u', 'a', 'af'].includes(type) && userId.length >= 5 && userId.length <= 12;
			}
			const hasTokenCookie = (req) => {
				return req.headers?.cookie && req.headers.cookie.includes('token');
			}

			const setReferralCookies = (res, referral) => {
				const cookies = [];
				if (referral?.country_code) cookies.push(`country_code=${referral?.country_code};PATH=/`);
				if (referral?.currency) cookies.push(`currency=${referral?.currency}; PATH=/`);
				res.setHeader('Set-Cookie', cookies);
			}
			if (!isValidUser(type, userId)) return redirect('/');


			// To get the client domain
			const referrerHeader = {
				'Cache-Control': 'no-cache'
			}
			if (process.server && req?.headers?.host) referrerHeader.origin = req.headers.host;

			let path = `/players/referer-info/${userId}`;
			if ($config.PRODUCTION && process.server) {
				path = $config.SERVER_URL + path;
			}
			const resReferral = await store.app.$axios.get(path, {
				retry: 5, retryDelay: 500, headers: referrerHeader
			});
			const referral = resReferral?.data;

			if (process.server && !hasTokenCookie(req)) {
				setReferralCookies(res, referral);
			}
		} catch (error) {
		}
	},

	async created() {
		if (process.client) {
			try {
				this.$cookie.set('previous_url', document.referrer);
				const { type, id: userId } = this.$route.params;
				if (!this.isValidUser(type, userId)) return this.$router.push('/');

				let path = `/players/referer-info/${userId}`;
				if (this.$config.PRODUCTION && process.server) {
					path = this.$config.SERVER_URL + path;
				}

				const resReferral = await this.$axios.get(path, {
					retry: 5, retryDelay: 500, headers: {
						'Cache-Control': 'no-cache'
					}
				});
				const referral = resReferral?.data;

				if (!this.$cookie.get('token')) {
					const cookieExpiredIn10Days = 60 * 60 * 24 * 10
					this.$cookie.remove('referral')
					if (referral?.exists) {
						this.$cookie.set(
							'referral',
							{ type, userId, currency: referral?.currency },
							{ maxAge: cookieExpiredIn10Days, path: '/' }
						);
						if (document.referrer) {
							this.$cookie.set('x-referral-url', document.referrer, {
								maxAge: cookieExpiredIn10Days, path: '/'
							})
						}
					}
					if (referral.currency) this.$cookie.set('currency', referral.currency, { expires: new Date('2100-01-01'), path: '/' })
					if (referral.country_code) this.$cookie.set('country_code', referral.country_code, { expires: new Date('2100-01-01'), path: '/' })
					this.$router.push('/register');
				} else {
					this.$router.push('/');
				}
			} catch (error) {
				this.$cookie.remove('referral')
				this.$router.push('/');
			}
		}
	},

	methods: {
		isValidUser(type, userId) {
			return ['u', 'a', 'af'].includes(type) && userId.length >= 5 && userId.length <= 12;
		},

	},
};
